module.exports = __webpack_public_path__ + "static/media/lighthouse710_logo.cf48b5e4.svg";